import {
    useQuery,
    useMutation
} from "@tanstack/react-query";
import axios from "@/axios.config";
import { ApiResponse } from "@/types/fetch.type";
import { CreateFineRequest, Fine, UpdateFineRequest } from "@/types";
import { AxiosError } from "axios";

export const useGetAllFines = () => {
    return useQuery<ApiResponse<Fine[]>, AxiosError<{ message: string }>>({
        queryKey: ["fines"],
        queryFn: async () => {
            const response = await axios.get<ApiResponse<Fine[]>>("/fines");
            return response.data;
        },
    });
}

export const useGetFinesByCouncil = (councilId: string) => {
    return useQuery<ApiResponse<Fine[]>, AxiosError<{ message: string }>>({
        queryKey: ["fines", councilId],
        queryFn: async () => {
            const response = await axios.get<ApiResponse<Fine[]>>(`/fines/council/${councilId}`);
            return response.data;
        },
        enabled: !!councilId,
    });
}

export const useGetFinesByCouncilAndService = (params: {
    councilId: string;
    serviceId: string;
}) => {
    return useQuery<ApiResponse<Fine>, AxiosError<{ message: string }>>({
        queryKey: ["fines", params.councilId, params.serviceId],
        queryFn: async () => {
            const response = await axios.get<ApiResponse<Fine>>(`/fines/by-council-and-service?councilId=${params.councilId}&serviceId=${params.serviceId}`);
            return response.data;
        },
        enabled: !!params.councilId && !!params.serviceId,
    });
}

export const useCreateFine = () => {
    return useMutation<ApiResponse<Fine>, AxiosError<{ message: string }>, CreateFineRequest>({
        mutationFn: async (params) => {
            const response = await axios.post<ApiResponse<Fine>>("/fines", params);
            return response.data;
        },
    });
}

export const useUpdateFine = () => {
    return useMutation<ApiResponse<Fine>, AxiosError<{ message: string }>, UpdateFineRequest>({
        mutationFn: async (params) => {
            const response = await axios.put<ApiResponse<Fine>>(`/fines/${params.id}`, params);
            return response.data;
        },
    });
}

export const useDeleteFine = () => {
    return useMutation<ApiResponse<Fine>, AxiosError<{ message: string }>, string>({
        mutationFn: async (id) => {
            const response = await axios.delete<ApiResponse<Fine>>(`/fines/${id}`);
            return response.data;
        },
    });
}
